import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Большая стрелка над проблемным местом: прокручивает к нему, подсвечивает и следует за ним
 * при прокрутке. Исчезает по нажатию — или когда её убирает родитель (ошибка устранена).
 */
export function PointerArrow({ selector, text, nonce, onClose }: { selector: string; text: string; nonce: number; onClose: () => void }) {
  const [box, setBox] = useState<{ top: number; left: number } | null>(null);

  useEffect(() => {
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [selector, nonce]);

  useEffect(() => {
    let raf = 0;
    let marked: Element | null = null;
    let last = '';
    // Место может перерисоваться или сдвинуться (раскрылся блок, загрузился файл) — ищем его каждый кадр.
    const tick = () => {
      const el = document.querySelector(selector);
      if (el !== marked) {
        marked?.classList.remove('pointer-target');
        el?.classList.add('pointer-target');
        marked = el;
      }
      const r = el?.getBoundingClientRect();
      const next = r && r.width > 0 ? { top: r.top, left: r.left + Math.min(40, r.width / 2) } : null;
      const key = next ? `${Math.round(next.top)}:${Math.round(next.left)}` : '';
      if (key !== last) {
        last = key;
        setBox(next);
      }
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => {
      cancelAnimationFrame(raf);
      marked?.classList.remove('pointer-target');
    };
  }, [selector]);

  if (!box) return null;
  return createPortal(
    <button type="button" className="pointer-arrow" style={{ top: box.top, left: box.left }} onClick={onClose} title="Понятно, скрыть стрелку">
      <span className="pointer-arrow-text">{text}</span>
      <svg viewBox="0 0 48 56" width="48" height="56" aria-hidden>
        <path d="M24 54 L4 30 H16 V2 H32 V30 H44 Z" />
      </svg>
    </button>,
    document.body,
  );
}
